import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { AlertTriangle } from "lucide-react";
import { useModalDismiss } from "./useModalDismiss";

interface Props {
    title: string;
    subtitle?: string;
    confirmLabel: string;
    danger?: boolean;
    warning?: { tone: "danger" | "info"; text: string } | null;
    onConfirm: (reviewNote: string | null) => void;
    onCancel: () => void;
}

export default function ReviewProposalModal({
    title,
    subtitle,
    confirmLabel,
    danger = false,
    warning = null,
    onConfirm,
    onCancel,
}: Props) {
    const [note, setNote] = useState("");
    const { show, dismiss, onExited } = useModalDismiss(onCancel, () => {
        const trimmed = note.trim();
        onConfirm(trimmed.length ? trimmed : null);
    });

    return (
        <Modal show={show} onHide={() => dismiss("cancel")} onExited={onExited} centered scrollable backdropClassName="m-modal-backdrop">
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 17, fontWeight: 600 }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {subtitle && <p style={{ fontSize: 13, color: "#64748b", marginTop: 0, marginBottom: 12 }}>{subtitle}</p>}
                {warning && (
                    <div className={`m-review-warning m-review-warning-${warning.tone}`}>
                        <AlertTriangle size={16} className="m-review-warning-icon" />
                        <span>{warning.text}</span>
                    </div>
                )}
                <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: "#334155", marginBottom: 6 }}>
                    Review note (optional)
                </label>
                <textarea
                    className="m-input"
                    rows={3}
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder="Add a note for the requester..."
                    autoFocus
                />
            </Modal.Body>
            <Modal.Footer>
                <button className="m-btn m-btn-ghost" onClick={() => dismiss("cancel")}>Cancel</button>
                <button
                    className={`m-btn ${danger ? "m-btn-danger" : "m-btn-primary"}`}
                    onClick={() => dismiss("save")}
                >
                    {confirmLabel}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
